import { createContext } from 'react';
import { Zone } from '../../models';

export interface ZoneContextValue {
  data: Zone[];
  working: boolean;
}

export const ZoneContext = createContext<ZoneContextValue>({ data: [], working: false });
